var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4448_324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H209.24V209.24H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4448_324)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4448_324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.62 0C46.8385 0 0 46.8385 0 104.62C0 162.401 46.8385 209.24 104.62 209.24C162.401 209.24 209.24 162.401 209.24 104.62C209.24 46.8385 162.401 0 104.62 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4448_324)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4448_324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 211,
    height: 211
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.906 -0.046875H-0.760498V209.286H209.906V-0.046875Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4448_324)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4448_324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H209.24V209.24H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4448_324)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4448_324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.62 0C46.8385 0 0 46.8385 0 104.62C0 162.401 46.8385 209.24 104.62 209.24C162.401 209.24 209.24 162.401 209.24 104.62C209.24 46.8385 162.401 0 104.62 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4448_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H209.24V209.24H0V0Z",
    fill: "black"
  }))))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.943 72.7396C139.854 69.8906 135.797 69.1458 132.802 71.2448C129.953 73.3437 129.198 77.3906 131.297 80.3854C136.401 87.4271 139.094 95.8229 139.094 104.672C139.094 113.51 136.401 121.906 131.297 128.958C129.198 131.802 129.802 136 132.802 138.099C134 139 135.344 139.302 136.542 139.302C138.5 139.302 140.599 138.406 141.792 136.594C148.542 127.302 152.146 116.214 152.146 104.672C152.281 93.1302 148.693 82.1823 141.943 72.7396Z",
    fill: "#FEC000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.578 55.6564C156.328 52.8022 152.281 52.3595 149.438 54.6095C146.594 56.8439 146.151 60.9012 148.391 63.7501C157.833 75.4428 162.776 89.5262 162.776 104.521C162.776 119.516 157.833 133.599 148.391 145.292C146.151 148.141 146.594 152.198 149.438 154.432C150.641 155.333 152.13 155.938 153.484 155.938C155.443 155.938 157.24 155.042 158.578 153.537C169.677 139.745 175.823 122.359 175.823 104.521C175.823 86.6824 169.677 69.5887 158.578 55.6564Z",
    fill: "#FEC000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4448_324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 44,
    width: 85,
    height: 122
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4165 44.0886H117.568V165.089H33.4165V44.0886Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4448_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.364 44.5574C112.708 43.8126 110.917 43.9637 109.411 45.0106L64.4425 79.0314H38.0675C35.5155 79.0314 33.4165 81.1303 33.4165 83.6876V125.662C33.4165 128.203 35.5155 130.302 38.0675 130.302H64.4425L109.562 164.333C110.323 164.927 111.37 165.229 112.406 165.229C113.167 165.229 113.76 165.078 114.505 164.776C116.161 164.031 117.057 162.386 117.057 160.594V48.7553C117.057 46.9585 116.01 45.3022 114.364 44.5574Z",
    fill: "#FEC000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.ce58e7d1731228848b997caed2bba1fa.svg";
export { ForwardRef as ReactComponent };